export enum PermissionScopeEnum {
  WebsiteExample1 = 'WebsiteExample1',
  WebsiteExample2 = 'WebsiteExample2',
  WebsiteExample3 = 'WebsiteExample3'
}
